(function ($) {
  'use strict';

  /**
   * Main functionality should be in an 'init' function
   */
  var homepageHeroSliderInit = function () {
    var self = $(this);
    var breakpoint = window.matchMedia('(min-width: 768px)');
    var $videos = $('.cc--hero-stories-full-width-carousel-slide', self).find('video');
    var $videoWrapper = $('.cc--hero-stories-full-width-carousel-slide', self).find('.f--ambient-video');

    if($videoWrapper.length > 0) {
      $videoWrapper.attr('aria-hidden', 'true');
      $videoWrapper.find('video').attr('aria-hidden', 'true');
    }

    var checkBreakpoint = function () {
      $videos = $('.cc--hero-stories-full-width-carousel-slide', self).find('video');

      if (breakpoint.matches) {
        $videos.each(function (i, el) {
          $(el).attr('autoplay', '');
          el.play();
        });
      }
      else {
        $videos.each(function (i, el) {
          $(el).removeAttr('autoplay');
          el.pause();
        });
      }
    };

	$videos.each(function (i, el) {
		$(el).parents('.c--hero-stories-full-width-carousel-slide').find('.cc--video-controls .video-pause-button').removeAttr('disabled');
	})

    breakpoint.addEventListener('change', checkBreakpoint());

    var $slidesCount = $('.cc--hero-stories-full-width-carousel-slide').length;

    /* eslint no-undef: "off" */
    /* eslint no-unused-vars: "off" */
    var mySwiper = new Swiper('.cc--hero-stories-full-width-carousel .swiper-container', {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      watchOverflow: true,
      a11y: true,
      rewind: $slidesCount > 1,
      simulateTouch: false,
      navigation: {
        nextEl: '.button-next', self,
        prevEl: '.button-prev', self,
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
      on: {
        imagesReady: function () {
          $('.swiper-slide:not(.swiper-slide-visible)', self).attr('aria-hidden', true);
          $('.swiper-slide:not(.swiper-slide-visible)', self).attr('tabindex', '-1');
          $('.swiper-slide:not(.swiper-slide-visible)', self).find('a, button').attr({
            'aria-hidden': true,
            'tabindex': -1
          });
          $('.swiper-slide-visible', self).attr('aria-hidden', false);
          $('.swiper-slide-visible', self).attr('tabindex', '0');
        },
        slideChangeTransitionEnd: function () {
          $('.swiper-slide:not(.swiper-slide-visible)', self).attr('aria-hidden', true);
          $('.swiper-slide:not(.swiper-slide-visible)', self).attr('tabindex', '-1');
          $('.swiper-slide:not(.swiper-slide-visible)', self).find('a, button').attr({
            'aria-hidden': true,
            'tabindex': -1
          });
          $('.swiper-slide-visible', self).attr('aria-hidden', false);
          $('.swiper-slide-visible', self).attr('tabindex', '0');
          $('.swiper-slide-visible', self).find('a, button').attr({
            'aria-hidden': false,
            'tabindex': 0
          });
        }
      }
    });


	ScrollTrigger.observe({
		target: window,
		type: 'scroll',
		onUp: () => {
			window.pageYOffset == 0 && !$('html').hasClass('main-menu-open') ? $('body').addClass('transparent-header') : null;
		}
	});
  };

	/**
	 * This is boilerplate: add a behavior to window.DP.behaviors
	 */
	window.DP.behaviors.homepageHeroSlider = {
		attach: function (context) {
			// console.log(context);
			// console.log(window.DP.behaviors);
			$(context).find('.cc--hero-stories-full-width-carousel').once('homepageHeroSlider').each(function () {
				homepageHeroSliderInit.apply(this);
			});
		}
	};

}(jQuery));
